import { useMutation, useQueryClient } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/contexts/AuthContext";
import { LanguageCode, setStoredLanguage } from "@/lib/languages";

export type Language = LanguageCode;

export const useUpdateProfileLanguage = (options?: { reloadOnSuccess?: boolean }) => {
  const queryClient = useQueryClient();
  const { user, refetchProfile } = useAuth();
  const reloadOnSuccess = options?.reloadOnSuccess ?? false;

  return useMutation({
    mutationFn: async (language: LanguageCode) => {
      if (!user) throw new Error("Not authenticated");

      // Also update localStorage
      setStoredLanguage(language);

      const { error } = await supabase
        .from("profiles")
        .update({ language })
        .eq("id", user.id);

      if (error) throw error;
    },
    onSuccess: async () => {
      // Refetch profile to update language in AuthContext
      await refetchProfile();
      queryClient.invalidateQueries({ queryKey: ["profile"] });
      
      // Force page reload to clear translation caches if requested
      if (reloadOnSuccess) {
        window.location.reload();
      }
    },
  });
};
